import type { CSSProperties, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function AudienceDetailsSection({
  icon: Icon,
  title,
  titleAside,
  description,
  actions,
  children,
  className,
  style,
}: {
  icon: LucideIcon;
  title: string;
  titleAside?: ReactNode;
  description: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <section className={cn('flex flex-col gap-4', className)} style={style}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex min-w-0 flex-col gap-1">
          <h2 className="flex items-center gap-2 text-base font-medium">
            <Icon data-icon="inline-start" className="size-4 shrink-0" />
            <span className="truncate">{title}</span>
            {titleAside}
          </h2>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
        {actions ? (
          <div className="flex shrink-0 items-center gap-2">{actions}</div>
        ) : null}
      </div>
      {children}
    </section>
  );
}
